export function lightboxMobileMediaHeight(viewportHeight: number): string {
	return `${Math.min(800, Math.round(viewportHeight * 0.5))}px`;
}
